import React from 'react';
import classes from './MenuToggle.module.css';

const menuToggle = () => {
  return (
    <div className={classes.MenuToggle}>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default menuToggle;
